import React from "react";
import Tooltip from "@mui/material/Tooltip";
import MessageIcon from "@mui/icons-material/Message";
import { useRecordContext } from "ra-core";

const ChatBubbleTooltip = (_props?: { source?: string; label?: string }) => {
  const record = useRecordContext();
  if (record === undefined) {
    return null;
  }

  return record.notes ? (
    <Tooltip
      title={
        <p
          style={{
            fontSize: "1.4em",
            lineHeight: 1,
            paddingLeft: "0.7em",
            paddingRight: "0.7em",
          }}
        >
          {record.notes}
        </p>
      }
    >
      <MessageIcon />
    </Tooltip>
  ) : null;
};

export { ChatBubbleTooltip };
